import type { LibrarySearch } from '@studio/types';

const filterAndSortTagFacets = (
  tags: LibrarySearch.Get.FacetValue[],
  searchRequest: LibrarySearch.Get.Params,
  filter: string
): LibrarySearch.Derived.TagFacet[] => {
  return tags
    .map<LibrarySearch.Derived.TagFacet>((tag) => ({
      count: tag.count,
      name: tag.name,
      checked: Boolean(searchRequest.tags?.includes(tag.name)),
    }))
    .filter((tag) => tag.checked || tag.name.includes(filter))
    .sort((b, a) => Number(a.checked) - Number(b.checked));
};

export default filterAndSortTagFacets;
